import { Navigate } from "src/router";
import type { RouteObject } from "src/router";

// The Native Delivery nav now points at Reporting, so this path has no entry
// point. It stays routed as a redirect rather than 404ing, because bookmarks and
// shared links to the old Deliverability page still exist and would otherwise
// dead-end with no way into the page that replaced it. The splat carries the
// per-channel children (`/deliverability/email`) to the same place.
//
// The page component itself is still in the tree; the retire PR deletes it.
export const routes: RouteObject[] = [
  {
    path: "native-delivery/deliverability/*",
    spacesAccess: "hidden-from-limited-view",
    element: (
      <Navigate to="/native-delivery/reporting/deliverability" replace />
    ),
  },
];
